import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Params, Router } from '@angular/router';

import { ERROR_CTA_ACTIONS } from '@fcom/common/components';
import { LanguageService } from '@fcom/ui-translate';
import { RootPaths } from '@fcom/core';

import { navigateToError } from '../utils/routing.utils';

@Injectable()
export class ManageBookingErrorRouteGuard implements CanActivate {
  constructor(
    private router: Router,
    private languageService: LanguageService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const errorParams: Params = {
      iconName: route.queryParams?.iconName,
      title: route.queryParams?.title ?? 'sorry',
      subtitle: route.queryParams?.subtitle ?? 'errors.payment.title',
      info: route.queryParams?.info ?? 'errors.payment.description',
      cta: route.queryParams?.cta ?? 'errors.generic.cta',
      ctaAction: ERROR_CTA_ACTIONS.NAVIGATE_TO_MANAGE_BOOKING,
      showButton: true,
    };

    // To clear the url params altogether, we need to work around the routing behavior a bit
    // We have the possible params saved to our errorParams object, that we got from /payment/error?params=...
    // First we clear current queryParams by navigating to the generic /error route without any params and overwriting the history
    const targetUrl = `/${this.languageService.langValue}/${RootPaths.MANAGE_BOOKING_ROOT}/error`;
    this.router
      .navigateByUrl(targetUrl, { replaceUrl: true })
      .then(() => {
        // The second navigation here is the actual navigation to the /error where we pass the saved errorParams from before
        navigateToError(this.router, this.languageService.langValue, 'MMB_PAYMENT_ERROR', errorParams);
      })
      .catch(() => Promise.reject());

    return false;
  }
}
